export class CardSensitiveData {
  value: string;
  expirationDate: Date;
  cvv: string;

  constructor(object: any = null) {
    if (object != null) {
      Object.assign(this, object);
    }
    if (object.expirationDate != null) {

    }
  }
}